<template>
  <div class="html-container">
    <iframe
      ref="iframe"
      width="100%"
      height="100%"
      frameborder="0"
      scrolling="no"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'BaseHtmlContainer',
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const iframeBody = `
                      <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
                      <html>
                        <head>
                          <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                          <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        </head>
                        <body>
                          <span>
                            ` + this.content + `
                          </span>
                        </body>
                        </html>
                      `
    const iFrameEl = this.$refs.iframe
    const doc = iFrameEl.contentWindow.document

    doc.open()
    doc.write(iframeBody)
    doc.close()

    iFrameEl.onload = () => {
      iFrameEl.style.height = `${doc.body.scrollHeight + 5}px`
    }
  },
}
</script>
